/* global localData */

// **************************************************
// Add comparison
// **************************************************
const initComparison = () => {
  const comparisonButtons = document.querySelectorAll('.compare-button');
  comparisonButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      if (button.innerHTML !== button.dataset.altertext) {
        e.preventDefault();
        let compareCookie = getCookie('wc_compare');
        if (compareCookie) {
          compareCookie = JSON.parse(compareCookie);
          compareCookie.push(button.dataset.productid);
        } else {
          compareCookie = [button.dataset.productid];
        }
        setCookie('wc_compare', JSON.stringify(compareCookie));
      }
      // eslint-disable-next-line no-param-reassign
      button.innerHTML = button.dataset.altertext;
    });
  });
};

// **************************************************
// Filter toggle
// **************************************************
if (document.querySelector('.sc-shop-category-list')) {
  initPopups();
  const sortTitle = document.querySelector('.sort__title');
  const filterContent = document.querySelector('.sort__content');

  if (sortTitle) {
    const filterItem = sortTitle.closest('.shop-category-list__sort');

    sortTitle.addEventListener('click', () => {
      filterItem.classList.toggle('is-open');
      slideToggle(filterContent, 300, 'grid');
    });

    document.addEventListener('click', (ev) => {
      const clickInside = filterItem.contains(ev.target);

      if (!clickInside) {
        filterItem.classList.remove('is-open');
        slideUp(filterContent, 300, 'grid');
      }
    });
  }

  // **************************************************
  // Filter
  // **************************************************

  const parentEle = document.querySelector('.sc-shop-category-list');
  const filterEle = parentEle.querySelectorAll('.shop-dropdown-filter');
  const filterParent = parentEle.querySelector('.shop-category-list__left');
  const filterBack = parentEle.querySelector('.shop-category-list__left-back');
  const filterTitleEle = parentEle.querySelectorAll('.shop-dropdown-filter__title');
  const filterMobileTitle = parentEle.querySelector('.shop-category-list__left-title');
  const filterTrigger = parentEle.querySelector('.shop-category-list__filter-toggle');
  const filterCloseButton = parentEle.querySelector('.shop-category-list__left-close');
  const filterClose = parentEle.querySelector('.shop-category-list__left-confirm');

  // Change Filter Title Text
  if (filterTitleEle) {
    filterTitleEle.forEach((filterTitle) => {
      const filterTitleText = filterTitle.querySelector('h3');

      filterTitle.addEventListener('click', () => {
        filterMobileTitle.innerHTML = filterTitleText.innerHTML;
      });
    });
  }

  // Remove Open Filter When Click On BackLink
  if (filterBack) {
    filterBack.addEventListener('click', () => {
      filterEle.forEach((ele) => {
        ele.classList.remove('is-open-filter');
        document.body.classList.remove('is-open-filter');
      });
    });
  }

  // Open Filter
  if (filterTrigger) {
    filterTrigger.addEventListener('click', () => {
      filterParent.classList.add('is-open');

      if (sortTitle) {
        const filterItem = sortTitle.closest('.shop-category-list__sort');
        filterItem.classList.remove('is-open');
        slideUp(filterContent, 300);
      }
    });
  }

  // Close Filter
  if (filterClose) {
    filterClose.addEventListener('click', () => {
      filterParent.classList.remove('is-open');

      if (filterEle) {
        document.body.classList.remove('is-open-filter');
        filterEle.forEach((ele) => {
          ele.classList.remove('is-open-filter');
        });
      }
    });

    // Close Modal When Escape Key Press
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        document.querySelectorAll('.shop-category-list__left.is-open').forEach((el) => {
          el.classList.remove('is-open');
        });
      }
    });
  }

  // Close Filter When Click On Cross Button
  if (filterCloseButton) {
    filterCloseButton.addEventListener('click', () => {
      filterParent.classList.remove('is-open');

      if (filterEle) {
        document.body.classList.remove('is-open-filter');
        filterEle.forEach((ele) => {
          ele.classList.remove('is-open-filter');
        });
      }
    });

    // Close Modal When Escape Key Press
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        document.querySelectorAll('.shop-category-list__left.is-open').forEach((el) => {
          el.classList.remove('is-open');
        });
      }
    });
  }

  // **************************************************
  // Load more, filter and sort via Axios
  // **************************************************
  const filterButtons = document.querySelectorAll('.shop-category-list__filters input');
  const clearFilters = document.querySelectorAll('.shop-category-list__filters-clear');

  const getSelectedFilterItems = () => {
    const filterItems = [];
    filterButtons.forEach((f) => {
      if (f.checked) {
        filterItems.push(f.id);
      }
    });
    return filterItems;
  };

  initComparison();

  const loadMoreAxios = (subAction) => {
    const listContainer = document.querySelector('#list-container');
    let pageIndex = 1;
    if (subAction === 'load-more') {
      pageIndex = document.querySelector('.shop-category-list__more').getAttribute('data-load-more-index');
    }
    const urlPath = window.location.pathname.split('/');
    const formDataInput = new FormData();
    formDataInput.append('action', 'shopCategoryLoadMore');
    formDataInput.append('lang', localData.lang);
    formDataInput.append('id', localData.id);
    formDataInput.append('page', pageIndex);
    formDataInput.append('category', urlPath.pop() || urlPath.pop());
    if (subAction === 'clear-filters') {
      formDataInput.append('filter', 'clear-filters');
    } else {
      formDataInput.append('filter', getSelectedFilterItems());
      const searchParams = getSelectedFilterItems().join('&');
      window.history.pushState(window.location.href, null, `?${searchParams}`);
    }
    if (document.querySelector('.shop-category-list__more').getAttribute('data-sort-by')) {
      formDataInput.append('sort_by', document.querySelector('.shop-category-list__more').getAttribute('data-sort-by'));
    }
    if (document.querySelector('.shop-category-list__more').getAttribute('data-sort')) {
      formDataInput.append('order', document.querySelector('.shop-category-list__more').getAttribute('data-sort'));
    }
    axios
      .post(localData.siteURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (subAction === 'load-more') {
            document.querySelector('.shop-category-list__more').setAttribute('data-load-more-index', +pageIndex + 1);
            if (response.data.load_more_action) {
              document.querySelector('.shop-category-list__products').innerHTML += response.data.cards;
            } else {
              listContainer.innerHTML += response.data.cards;
            }
          } else {
            listContainer.innerHTML = response.data.cards;
          }
          initPopups();
          initComparison();
        }
        if (!response.data.more) {
          document.querySelector('.shop-category-list__more').innerHTML = '';
        } else if (subAction !== 'load-more') {
          document.querySelector('.shop-category-list__more').innerHTML = response.data.load_more_button;
          // eslint-disable-next-line no-use-before-define
          loadMoraAction('load-more');
        }
        toggleLoader(false);
        initPopups();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  if (clearFilters) {
    clearFilters.forEach((clearFilter) => {
      clearFilter.addEventListener('click', () => {
        filterButtons.forEach((button) => {
          // eslint-disable-next-line no-param-reassign
          button.checked = false;
        });
        const mobileFilterButton = document.querySelectorAll('.shop-dropdown-filter__selected-items');
        mobileFilterButton.forEach((mobileButton) => {
          // eslint-disable-next-line no-param-reassign
          mobileButton.innerHTML = '';
        });
        toggleLoader(true);
        loadMoreAxios('clear-filters');
      });
    });
  }

  const loadMoraAction = (subAction) => {
    document.querySelector('.shop-category-list__more-btn').addEventListener('click', () => {
      toggleLoader(true);
      loadMoreAxios(subAction);
    });
  };
  if (document.querySelector('.shop-category-list__more-btn')) {
    loadMoraAction('load-more');
  }

  filterButtons.forEach((filter) => {
    filter.addEventListener('click', () => {
      document.querySelector('.shop-category-list__more').setAttribute('data-load-more-index', 2);
      toggleLoader(true);
      loadMoreAxios('filter');
    });
  });

  const sortButtons = document.querySelectorAll('.sort__content a');
  sortButtons.forEach((sortBy) => {
    sortBy.addEventListener('click', (sortSelection) => {

      const allActives = document.querySelectorAll('.sort__content a.is-active');
      allActives.forEach((active) => {
        active.classList.remove('is-active');
      });

      sortBy.classList.toggle('is-active');
      sortSelection.preventDefault();
      const sortByType = sortSelection.target.getAttribute('data-sort-by');
      const orderType = sortSelection.target.getAttribute('data-sort');
      document.querySelector('.shop-category-list__more').setAttribute('data-sort-by', sortByType);
      document.querySelector('.shop-category-list__more').setAttribute('data-sort', orderType);
      document.querySelector('.shop-category-list__more').setAttribute('data-load-more-index', 2);
      slideToggle(filterContent, 300, 'inline-grid');

      if (sortTitle) {
        const filterItem = sortTitle.closest('.shop-category-list__sort');
        filterItem.classList.remove('is-open');
      }
      toggleLoader(true);
      loadMoreAxios('sort');
    });
  });
}
